export const analyticsIt = {
  bookingAnalytics: {
    navigation: {
      analytics: 'Analytics',
    },
    title: 'Analytics delle Prenotazioni',
    description: 'Monitora le prestazioni del tuo studio e il comportamento delle prenotazioni',
    banner: 'Le analytics vengono tracciate dalla pagina pubblica di prenotazione. La raccolta dei dati inizia quando gli utenti visitano la tua pagina studio.',

    tabs: {
      overview: 'Panoramica',
      funnel: 'Imbuto di Prenotazione',
      performance: 'Prestazioni',
      behavior: 'Comportamento Utente',
    },

    overview: {
      total_views: 'Visualizzazioni Totali',
      booking_starts: 'Inizi Prenotazione',
      completions: 'Completamenti',
      conversion_rate: 'Tasso di Conversione',
      all_time: 'Sempre',
      users_who_started: 'Utenti che hanno iniziato la prenotazione',
      successful_bookings: 'Prenotazioni riuscite',
      view_to_booking: 'Vista a prenotazione',
    },

    funnel: {
      title: 'Analisi dell\'Imbuto di Prenotazione',
      description: 'Monitora come gli utenti progrediscono attraverso il processo di prenotazione',
      studio_views: 'Visualizzazioni Pagina Studio',
      booking_starts: 'Prenotazione Iniziata',
      room_selections: 'Sala Selezionata',
      date_selections: 'Data/Ora Selezionata',
      completions: 'Prenotazione Completata',
    },

    performance: {
      coming_soon: 'Metriche dettagliate delle prestazioni in arrivo. Monitora sale popolari, fasce orarie e modelli di prenotazione.',
    },

    behavior: {
      coming_soon: 'Analytics del comportamento utente in arrivo. Comprendi l\'uso dei dispositivi, i modelli di engagement e le interazioni degli utenti.',
    },

    coming_soon: {
      title: 'Analytics Dettagliate in Arrivo',
      description: 'Stiamo attualmente raccogliendo dati analitici dalla tua pagina di prenotazione. Una volta raccolti dati sufficienti, vedrai grafici dettagliati, diagrammi e insights sulle prestazioni del tuo studio, orari di prenotazione popolari, preferenze delle sale e metriche di conversione.',
    },

    sharing: {
      title: 'Analytics di Condivisione',
      description: 'Monitora come viene condiviso il tuo studio e misura il successo delle referenze',
      no_data: 'Nessun dato di condivisione ancora. Condividi il tuo studio per iniziare a monitorare!',

      overview: {
        total_shares: 'Condivisioni Totali',
        total_clicks: 'Clic sui Link',
        total_bookings: 'Prenotazioni da Condivisioni',
        total_revenue: 'Entrate da Condivisioni',
        conversion_rate: 'Tasso di Conversione Condivisioni',
        click_to_view: 'Tasso Clic a Vista',
        view_to_booking: 'Tasso Vista a Prenotazione',
      },

      funnel: {
        title: 'Imbuto di Conversione Condivisioni',
        description: 'Monitora come i link condivisi si convertono in prenotazioni',
        clicks: 'Clic sui Link',
        views: 'Visualizzazioni Studio',
        booking_starts: 'Prenotazione Iniziata',
        completions: 'Prenotazioni Completate',
      },

      methods: {
        title: 'Prestazioni del Metodo di Condivisione',
        description: 'Vedi quali piattaforme generano più prenotazioni',
      },

      leaderboard: {
        title: 'Migliori Condivisori',
        description: 'Utenti che hanno generato più entrate attraverso la condivisione',
        rank: 'Posizione',
        name: 'Nome',
        shares: 'Condivisioni',
        bookings: 'Prenotazioni',
        revenue: 'Entrate',
        rewards: 'Ricompense',
      },
    },
  },
};
